module.exports = __webpack_public_path__ + "static/media/摄图网_3.0e85f121.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_208/images/摄图网_3.png
// module id = 1707
// module chunks = 0